import React from 'react'
import styled from '@emotion/styled'
import { Button } from '@mui/material'

const CustomBtn = styled(Button)`
    background-color: ${props => props.bgc ? props.bgc : "#F88523"};
    font-size: 14px;
    border-radius: 20px;
    font-family: PoppinsSB;
    margin:  0 5px;
    color:#fff;
    transition: .5s;
    cursor: pointer;
    z-index: 1;
    :hover{
      background-color: #fff;
      color: ${props => props.bgc ? props.bgc : "#F88523"};
    }

`

const CustomButton = (props) => {
  const {children} = props
  return (
    <CustomBtn variant='filled' {...props}>
        {children}
    </CustomBtn>
  )
}

export default CustomButton